import BaseContentDetailsPageNavView from "scripts/views/baseContentDetailsPageNavView";
import templateContentDetailsArticlePageNav from "templates/contentDetailsArticlePageNav.hbs";
import L from "lodash/fp";

class ContentDetailsArticlePageNavView extends BaseContentDetailsPageNavView {
  constructor(options) {
    super(options);
    this.organizationProperties = options.organizationProperties;
  }

  get template() {
    return templateContentDetailsArticlePageNav;
  }

  render() {
    const modelProps = this.model.toJSON();

    this.$el.html(
        this.template(
            L.merge(
                {
                  showComments: !this.organizationProperties.hideCommentsTab
                },
                modelProps,
            ),
        ),
    );

    this.updateLinkState();
    this.updatePosition();

    return this;
  }

}

export default ContentDetailsArticlePageNavView;
